module.exports = __webpack_public_path__ + "img/sign-64.7bcbbc2e.jpg";